module.exports = __webpack_public_path__ + "static/img/zhuanli.48037d7d.png";